import { useState, useEffect, useCallback } from "react";
import { fetchServiceAreas, updateServiceAreaStatus, deleteServiceArea, createServiceArea, updateServiceArea } from "./Service-area";

export default function useServiceAreas() {
    const [serviceAreas, setServiceAreas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [status, setStatus] = useState("All")
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const pageSize = 10;

    const loadServiceAreas = useCallback(async () => {
        setLoading(true);
        setError("");

        try {
            const params = {
                search: searchValue || "", // fallback if empty
                status: status || "",      // fallback if empty
                page: currentPage || 1,
                limit: pageSize || 10
            };

            // console.log("params", params)
            const response = await fetchServiceAreas(params);

            // console.log(response);
            // Extract the actual ServiceArea items and pagination
            if (response.success) {
                setServiceAreas(response.data || []); // <-- use response.data.data
                setTotalPages(response.pagination?.total_pages || 1);
            } else {
                setServiceAreas([]);
                setTotalPages(1);
            }
        } catch (err) {
            setError(err.response?.data?.message || "Failed to fetch ServiceAreas");
        } finally {
            setLoading(false);
        }
    }, [searchValue, status, currentPage]);


    useEffect(() => {
        loadServiceAreas();
    }, [loadServiceAreas]);

    const handleStatusToggle = async (id, newStatus) => {
        // console.log(id, newStatus)
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            // console.log(id, currentStatus)
            await updateServiceAreaStatus(id, newStatus);
            // console.log(res)
            setSuccess("Status updated successfully");
            loadServiceAreas();
            setLoading(false);
            return { success: true };
        } catch (err) {
            setError(err.response?.data?.message || "Failed to update status");
            return { success: false, message: err.response?.data?.message || "Failed to update status" };
        } finally {
            setLoading(false);
        }
    };


    const handledeleteServiceArea = async (id) => {
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            await deleteServiceArea(id); // your API call
            setSuccess("ServiceArea deleted successfully");
            loadServiceAreas(); // refresh list
            return { success: true }; // ✅ return success
        } catch (err) {
            const message = err.response?.data?.message || "Failed to delete ServiceArea";
            setError(message);
            return { success: false, message }; // ✅ return failure info
        } finally {
            setLoading(false);
        }
    };



    // create ServiceArea
    const saveServiceArea = async (ServiceAreaData) => {
        setLoading(true);
        setError("");
        setSuccess("");

        console.log(ServiceAreaData);
        try {
            const response = await createServiceArea(ServiceAreaData);
            console.log(response);
            setSuccess("ServiceArea created successfully");
            loadServiceAreas();
            return { success: true, data: response };
        } catch (err) {
            setError(err.response?.data?.message || "Failed to create ServiceArea");
            return { success: false, message: err.response?.data?.message || "Failed to create ServiceArea" };
        } finally {
            setLoading(false);
        }
    };

    // update ServiceArea
    const updateServiceAreaData = async (id, ServiceAreaData) => {
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            await updateServiceArea(id, ServiceAreaData);
            setSuccess("ServiceArea updated successfully");
            loadServiceAreas();
            return { success: true };
        } catch (err) {
            setError(err.response?.data?.message || "Failed to update ServiceArea");
            return { success: false, message: err.response?.data?.message || "Failed to update ServiceArea" };
        } finally {
            setLoading(false);
        }
    };

    return {
        serviceAreas,
        searchValue,
        setStatus,
        status,
        setSearchValue,
        currentPage,
        totalPages,
        loading,
        error,
        success,
        handlePageChange: setCurrentPage,
        handleStatusToggle,
        handledeleteServiceArea,
        saveServiceArea,
        updateServiceAreaData,
        resetAlerts: () => {
            setError("");
            setSuccess("");
        },
        setCurrentPage,
    };
}
